module.exports = __webpack_public_path__ + "static/media/primary1.13889625.png";